export enum FeatureToggle {
  campaignManagement = 'campaignManagement',
  campaignManagementContentPageSlots = 'rt_campaign_management_content_page_slots',
  campaignManagementContentPageIppDrafts = 'rt_campaign_management_content_ipp_drafts',
  campaignManagementPrimarySplitBanner = 'rt_campaign_management_primary_split_banner',
  campaignManagementRedemptionUrls = 'rt_redemption_urls',
  navigateToContentPage = 'rt_navigate_to_content_page',
  slotCreativeCreation = 'rt_slot_creative_creation',
  flyoutsOnCreativeManager = 'rt_flyout_on_creative_manager',
  shoppableItemListCreativeManager = 'rt_shoppable_item_list_on_creative_manager',
  shoppableItemListPagebuilder = 'rt_shoppable_item_list_on_page_builder',
  adminCalendarPage = 'rt_campaigns_admin_calendar_enabled',
  adminCreativesPage = 'rt_campaigns_admin_creatives_enabled',
}
